export default __webpack_public_path__ + "static/media/solution-spaghetti.caef6104.jpg";